import { getProxyUrl } from '@proxies/index'
import { Api } from './myApi'

export function API() {
  const token = { Authorization: 'Ninpo ' + sessionStorage.getItem('access_token') }

  let baseUrl = getProxyUrl('')

  // Normalizar la URL - asegurar que termine con /
  baseUrl = baseUrl.replace(/\/+$/, '') + '/'

  return new Api({
    baseApiParams: { headers: token },
    baseUrl: baseUrl,
  })
}
